export const ANONYMOUS = 'anonymous';
export const IS_PREMIUM = 'isPremium';
export const IS_BASIC = 'isBasic';

const userCompletedOnboarding = (type, settings) =>
  !!(settings && settings.onboarded && settings.onboarded.includes(type));

export const userCompletedFavoriteSpots = ({ user: { settings } }) =>
  userCompletedOnboarding('FAVORITE_SPOTS', settings);

export const getUserDetails = (state) => {
  const data = state.user.details;
  if (data) {
    return data;
  }
  return null;
};

export const getUserSettings = (state) => {
  const data = state.user.settings;
  if (data) {
    return data;
  }
  return null;
};

export const getUserEntitlements = (state) => {
  const data = state.user.entitlements;
  if (data) {
    return data;
  }
  return null;
};

export const getUserFavorites = (state) => {
  const data = state.user.favorites;
  if (data) {
    return data;
  }
  return null;
};

export const getBasicStatus = (state) => state.user.entitlements.includes('sl_basic');

/**
 * @description Gets the users premium status from a given state object
 * @param {{ user: { entitlements: [string] } }} state
 * @returns {boolean} Boolean determining premium status
 */
export const getPremiumStatus = (state) => state.user.entitlements.includes('sl_premium');

/**
 * @description Returns whether a user is anonymous, free, or premium
 * @param {{ user: { entitlements: [string] }, details: {} }} state
 * @returns {"anonymous"|"isBasic"|"isPremium"}
 */
export const getUserType = (state) => {
  const userDetails = getUserDetails(state);
  if (!userDetails) return ANONYMOUS;
  return getPremiumStatus(state) ? IS_PREMIUM : IS_BASIC;
};
